export const FilterAndSort = () => (
  <>
    <span className="t-sr-only">Filter and Sort</span>
    <svg
      width="23"
      height="13"
      viewBox="0 0 23 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2071_16562)">
        <path
          d="M9.75 4.5V4.034C9.74934 3.36214 9.48215 2.718 9.00708 2.24292C8.532 1.76785 7.88786 1.50066 7.216 1.5H6.75V0.5H5.75V1.5H5.284C4.68266 1.50064 4.10114 1.71512 3.6434 2.10509C3.18565 2.49506 2.8815 3.03511 2.78533 3.62871C2.68915 4.22231 2.80721 4.83077 3.1184 5.34533C3.42959 5.85989 3.91363 6.24701 4.484 6.4375L5.75 6.86V10.5H5.284C4.87728 10.4996 4.48733 10.3379 4.19974 10.0503C3.91214 9.76267 3.7504 9.37272 3.75 8.966V8.5H2.75V8.966C2.75066 9.63786 3.01785 10.282 3.49292 10.7571C3.968 11.2322 4.61214 11.4993 5.284 11.5H5.75V12.5H6.75V11.5H7.216C7.81734 11.4994 8.39886 11.2849 8.8566 10.8949C9.31435 10.5049 9.6185 9.96489 9.71467 9.37129C9.81085 8.77769 9.6928 8.16923 9.38161 7.65467C9.07041 7.14011 8.58637 6.75299 8.016 6.5625L6.75 6.14V2.5H7.216C7.62272 2.5004 8.01267 2.66214 8.30026 2.94974C8.58786 3.23733 8.7496 3.62728 8.75 4.034V4.5H9.75ZM7.7 7.5105C8.04563 7.62554 8.33905 7.85981 8.52773 8.17141C8.71642 8.483 8.78807 8.85157 8.72985 9.21116C8.67163 9.57075 8.48735 9.89789 8.20998 10.134C7.93262 10.3702 7.58027 10.4999 7.216 10.5H6.75V7.1935L7.7 7.5105ZM5.75 5.8065L4.8 5.4895C4.45437 5.37446 4.16096 5.14019 3.97227 4.82859C3.78358 4.517 3.71193 4.14843 3.77015 3.78884C3.82837 3.42925 4.01265 3.10211 4.29002 2.86597C4.56738 2.62983 4.91973 2.5001 5.284 2.5H5.75V5.8065Z"
          fill="#706A85"
        />
      </g>
      <g clipPath="url(#clip1_2071_16562)">
        <path
          d="M22.25 2.95801C22.25 3.30384 21.9708 3.58301 21.625 3.58301H12.875C12.5292 3.58301 12.25 3.30384 12.25 2.95801C12.25 2.61217 12.5292 2.33301 12.875 2.33301H21.625C21.9708 2.33301 22.25 2.61217 22.25 2.95801ZM14.9583 9.83301H12.875C12.5292 9.83301 12.25 10.1122 12.25 10.458C12.25 10.8038 12.5292 11.083 12.875 11.083H14.9583C15.3042 11.083 15.5833 10.8038 15.5833 10.458C15.5833 10.1122 15.3042 9.83301 14.9583 9.83301ZM18.2917 6.08301H12.875C12.5292 6.08301 12.25 6.36217 12.25 6.70801C12.25 7.05384 12.5292 7.33301 12.875 7.33301H18.2917C18.6375 7.33301 18.9167 7.05384 18.9167 6.70801C18.9167 6.36217 18.6375 6.08301 18.2917 6.08301Z"
          fill="#706A85"
        />
      </g>
      <defs>
        <clipPath id="clip0_2071_16562">
          <rect
            width="12"
            height="12"
            fill="white"
            transform="translate(0.25 0.5)"
          />
        </clipPath>
        <clipPath id="clip1_2071_16562">
          <rect
            width="10"
            height="10"
            fill="white"
            transform="translate(12.25 1.5)"
          />
        </clipPath>
      </defs>
    </svg>
  </>
);
